import * as React from 'react';
import { Route, Redirect } from "react-router-dom";
import { AppState } from '../../model/reducers';
import { NavigationPaths, NavigationRedirects, NavigationTabs } from '../../model/navigation/types';
import { connect } from 'react-redux';
import PageGroup from './PageGroup';

// ----------------- Props -----------------  //

interface LocalProps
{
    pages: NavigationPaths;
    redirects: NavigationRedirects;
    tabs: NavigationTabs;
}

interface StateProps
{

}

type Props = StateProps & LocalProps;

// ----------------- Class -----------------  //

class SubPages extends React.Component<Props>
{
    render ()
    {
        return (<>
            {Object.values(this.props.redirects).map((redirect, index) => (
                <Route key={`redirect-route-${index}`} path={redirect.url} render={(props)=>(<Redirect to={redirect.to}/>)} exact={redirect.exactUrl} />
            ))}
            {Object.values(this.props.pages).map((link, index) => (
                <Route key={`page-route-${index}`} path={link.url} render={(props)=>(<PageGroup link={link} tabs={this.props.tabs} />)} exact={link.exactUrl} />
            ))}
        </>);
    }
}

// ----------------- Export -----------------  //

const mapStateToProps = (state: AppState): StateProps => ({

});

export default connect(mapStateToProps)(SubPages);

// ------------------------------------------  //